(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-videos"] && !Shopify.designMode) return;
  try {
    (function(){var s=document.querySelector(".creator-videos.section-{{ section.id }}");if(!s)return;var g=s.querySelector(".creator-videos__grid"),i=s.querySelector(".creator-videos__indicator");if(!g||!i)return;var n=Math.max(1,Math.ceil(g.scrollWidth/g.clientWidth));for(var x=0;x<n;x++){var d=document.createElement("span");if(!x)d.className="is-active";i.appendChild(d)}g.addEventListener("scroll",function(){var p=Math.round(g.scrollLeft/(g.scrollWidth-g.clientWidth||1)*(n-1));Array.from(i.children).forEach(function(d,x){d.classList.toggle("is-active",x===p)})},{passive:true})}())
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-voices"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-expert-voices]').forEach((section) => {
      section.querySelectorAll('[data-expert-card]').forEach((card) => {
        card.addEventListener('click', () => {
          const flipped = card.classList.toggle('is-flipped');
          card.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemians-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var DESKTOP = '(min-width: 768px)';
  var GALLERY = 'product-info .product__media-wrapper';

  function setup(section) {
    if (section.dataset.gemiansVideoBound) return;
    section.dataset.gemiansVideoBound = '1';

    // A comment node marks where the section belongs in normal flow, so
    // returning it to mobile position never depends on guessing an index.
    var home = document.createComment('gemians-video-home');
    section.parentNode.insertBefore(home, section);

    var mq = window.matchMedia(DESKTOP);
    var attempts = 0;

    function place() {
      var gallery = document.querySelector(GALLERY);
      if (!gallery) return;
      // A zero-width viewport means layout has not settled — matchMedia would
      // report "mobile" for a desktop window and park the section in the wrong
      // place. Background tabs and prerendered pages report zero too, so this
      // has to keep asking rather than bail once: bailing without a retry is
      // what left the section stranded below the product block on a desktop
      // window. Bounded so a page that never lays out stops trying.
      if (!document.documentElement.clientWidth) {
        if (attempts++ < 20) schedule();
        return;
      }
      attempts = 0;
      var wantGallery = mq.matches;
      var inGallery = gallery.contains(section);
      if (wantGallery === inGallery) return; // already where it should be

      if (wantGallery) gallery.appendChild(section);
      else home.parentNode.insertBefore(section, home);

      // The gallery is sticky: left alone it pins to the viewport and rides
      // down over anything placed beneath it in the same column, which is
      // exactly what this section is. A sticky gallery and content below it in
      // the same column cannot both work, so while the videos live here the
      // gallery scrolls normally. Removed again the moment they move out.
      gallery.classList.toggle('gemians-video-in-gallery', wantGallery);

      // The carousel sized itself against the old container. Only fired on an
      // actual move, so this cannot turn into a resize loop.
      window.dispatchEvent(new Event('resize'));
    }

    var timer;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(place, 100);
    }

    place();
    if (mq.addEventListener) mq.addEventListener('change', place);
    else if (mq.addListener) mq.addListener(place);

    // Belt and braces. The matchMedia change event did not fire under viewport
    // emulation, and place() is a no-op unless the section is genuinely on the
    // wrong side of the breakpoint, so listening to resize as well costs
    // nothing and covers whatever else might swallow that event.
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
    // One more pass once everything has loaded, so a first run that bailed on
    // an unsettled layout still ends up in the right column.
    window.addEventListener('load', schedule);
  }

  function init() {
    var sections = document.querySelectorAll('.gemians-video[data-gemians-video-desktop="product_gallery"]');
    for (var i = 0; i < sections.length; i++) setup(sections[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
      const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
      if (slides.length < 2) return;
      const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
      let current = 0;
      let timer;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };
      const restart = () => {
        clearInterval(timer);
        if (carousel.dataset.autoplay === 'true') timer = setInterval(() => show(current + 1), Number(carousel.dataset.interval) || 5000);
      };
      carousel.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
      carousel.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); restart(); }));
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-vitality-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vitality-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-vitality-slide]')];
    const dots = [...carousel.querySelectorAll('[data-vitality-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    if (carousel.dataset.autoplay === 'true') timer = setInterval(() => show(current + 1), Number(carousel.dataset.interval) || 5000);
    document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(carousel) && timer) clearInterval(timer); }, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-comparison-table]').forEach((table) => {
    const sides = [...table.querySelectorAll('[data-comparison-side]')];
    const dots = [...table.parentElement.querySelectorAll('.product-comparison__dots span')];
    if (sides.length < 2) return;
    const show = (index) => { sides.forEach((side, i) => side.classList.toggle('is-active', i === index)); dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index)); };
    show(0);
    let startX = 0;
    table.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
    table.addEventListener('touchend', (event) => { const delta = event.changedTouches[0].clientX - startX; if (Math.abs(delta) > 40) show(delta < 0 ? 1 : 0); }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-work"] && !Shopify.designMode) return;
  try {
    
  (() => { const root = document.currentScript?.closest('.why-work'); if (!root) return; const cards = root.querySelector('.why-work__cards'); const dots = [...root.querySelectorAll('.why-work__dots span')]; const update = () => { const index = Math.round(cards.scrollLeft / (cards.scrollWidth - cards.clientWidth || 1) * (dots.length - 1)); dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index)); }; root.querySelector('.why-work__prev')?.addEventListener('click', () => cards.scrollBy({ left: -cards.clientWidth, behavior: 'smooth' })); root.querySelector('.why-work__next')?.addEventListener('click', () => cards.scrollBy({ left: cards.clientWidth, behavior: 'smooth' })); cards.addEventListener('scroll', update, { passive: true }); })();

  } catch(e) { console.error(e); }
})();
})();
